module.exports = __webpack_public_path__ + "static/media/inst.466e8ba2.svg";